import { render, staticRenderFns } from "./ManageServiceCost.vue?vue&type=template&id=afc59068&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ManageServiceCost.vue?vue&type=style&index=0&id=afc59068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc59068",
  null
  
)

export default component.exports